module.exports = __webpack_public_path__ + "img/motorcycle-motor.377f6a27.png";